
import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import List from 'containers/pages/customers/List'
import Detail from 'containers/pages/customers/detail'
import Form from 'containers/pages/customers/Form'

const UserPage = ({ location, match, currentUser }) => {
  if (location.pathname === '/customer/phone') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-customer-managementverify-phone-number-read') > -1) {
      return <List location={location} match={match} />
    }
    return <ForbiddenPage />
  }
  if (match.params.id && location.pathname.includes('/detail')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-customer-managementverify-phone-number-read') > -1) {
      return <Detail match={match} location={location} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('/edit') || location.pathname.includes('/add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-customer-managementverify-phone-number-write') > -1) {
      return <Form match={match} location={location} />
    }
    return <ForbiddenPage />
  }
  return ''
}

UserPage.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default UserPage
